import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { RequestService } from '../../../../services/request.service';

@Component({
  selector: 'app-close-request-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './close-request-modal.component.html',
  styleUrl: './close-request-modal.component.scss',
})
export class CloseRequestModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() requestClosed = new EventEmitter<{ note: string }>();

  note: string = '';
  type: number | null = null;
  causes: any[] = [];

  constructor(private requestService: RequestService) {}

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    const note = this.causes.find(c=> c.id == this.type).name + ' ' + this.note;
    this.requestClosed.emit({ note: note});
  }

  ngOnInit() {
    this.requestService.getCauses('CR').subscribe(result => {
      this.causes = result;
    })
  }
}
